<template>
	<div class="main">
    <section class="panel" v-if="isShowTreaty">
      <treaty :key="$route.fullPath" type="weak"></treaty>
    </section>
		<section class="panel" v-else>
			<div class="panel-body container-fluid">
				<div class="row form-group">
					<div class="col-md-3 form-group">
						<label for="name" class="col-sm-4 col-xs-2 column-required">姓名</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.name}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="name" name="name" v-validate="'required'" v-model="stu.name" type="text" class="form-control" maxlength="20"/>
							<span class="text-danger" v-show="errors.has('name')">{{ errors.first('name') }}</span>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="sex" class="col-sm-4 col-xs-2 column-required">性別</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.sex == 'M' ? '男' : '女'}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="sex" name="sex" ref="sex" v-validate="'required'" v-model="stu.sex" class="form-control">
								<option value="">請選擇</option>
								<option value="M">男</option>
								<option value="F">女</option>
							</select>
							<span class="text-danger" v-show="errors.has('sex')">{{ errors.first('sex') }}</span>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="account" class="col-sm-4 col-xs-2">學號</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.account}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="account" name="account" v-model="stu.account" type="text" class="form-control" @input="getLastYearData"/>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="idno" class="col-sm-4 col-xs-2 column-required">身分證字號</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.idno}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="idno" name="idno" v-validate="'required|idnoSex:sex'" v-model="stu.idno" type="text" class="form-control" maxlength="10"/>
							<span class="text-danger" v-show="errors.has('idno')">{{ errors.first('idno') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-3 form-group">
						<label for="ssym" class="col-sm-4 col-xs-2">學制</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{ssymList.some(ssym => ssym.commCode == stu.ssym) ?
							ssymList.filter(ssym => ssym.commCode == stu.ssym)[0].commValue :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="ssym" name="ssym" v-model="stu.ssym" class="form-control">
								<option value="">請選擇</option>
								<option v-for="(item,key) in ssymList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="dept" class="col-sm-4 col-xs-2">科系</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{deptList.some(dept => dept.commCode == stu.dept) ?
							deptList.filter(dept => dept.commCode == stu.dept)[0].commValue :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="dept" name="dept" v-model="stu.dept" class="form-control">
								<option value="">請選擇</option>
								<option v-for="(item,key) in deptList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="drade" class="col-sm-4 col-xs-2">年級</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{dradeList.some(drade => drade.key == stu.drade) ?
							dradeList.filter(drade => drade.key == stu.drade)[0].value :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="drade" name="drade" v-model="stu.drade" class="form-control">
								<option value="">請選擇</option>
								<option v-for="(item,key) in dradeList" :key="key" :value="item.key">{{ item.value }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="dradeClass" class="col-sm-4 col-xs-2">班級</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{dradeClassList.some(dradeClass => dradeClass.key == stu.dradeClass) ?
							dradeClassList.filter(dradeClass => dradeClass.key == stu.dradeClass)[0].value :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="dradeClass" name="dradeClass" v-model="stu.dradeClass" class="form-control">
								<option value="">請選擇</option>
								<option v-for="(item,key) in dradeClassList" :key="key" :value="item.key">{{ item.value }}
								</option>
							</select>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-3 form-group">
						<label for="state" class="col-sm-4 col-xs-2">在學狀態</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">
							{{uStateList.some(uState => uState.commCode == stu.state) ?
							uStateList.filter(uState => uState.commCode == stu.state)[0].commValue :
							''}}
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<select id="state" name="state" v-model="stu.state" class="form-control" disabled>
								<option v-for="(item,key) in uStateList" :key="key" :value="item.commCode">{{ item.commValue }}
								</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="entryYear" class="col-sm-4 col-xs-2">入學年</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.entryYear}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="entryYear" name="entryYear" v-model="stu.entryYear" type="number" class="form-control" />
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="entryMonth" class="col-sm-4 col-xs-2">入學月</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.entryMonth}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="entryMonth" name="entryMonth" v-model="stu.entryMonth" type="number" class="form-control" />
						</div>
					</div>
					<div class="col-md-3 form-group">
						<label for="phone" class="col-sm-4 col-xs-2">行動電話</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.phone}}</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input id="phone" name="phone" v-model="stu.phone" type="text" class="form-control" />
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-6 form-group">
						<label for="schMail" class="col-sm-2 col-xs-2">學校信箱</label>
						<div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.schMail}}</div>
						<div v-else class="col-sm-10 col-xs-10">
							<input id="schMail" name="schMail" v-model="stu.schMail" type="email" class="form-control" />
						</div>
					</div>
					<div class="col-md-6 form-group">
						<label for="extMail" class="col-sm-2 col-xs-2 column-required">個人信箱</label>
						<div v-if="!isEditable" class="col-sm-8 col-xs-10">{{stu.extMail}}</div>
						<div v-else class="col-sm-10 col-xs-10">
							<input id="extMail" name="extMail" v-validate="'required'" v-model="stu.extMail" type="email" class="form-control" />
							<span class="text-danger" v-show="errors.has('extMail')">{{ errors.first('extMail') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12 form-group" v-if="isInfo">
						<label class="col-xs-3">地址</label>
						<div class="col-xs-9 col-md-10">
							{{ stu.resiFullAddress }}
						</div>
					</div>
					<div class="col-md-12 form-group" v-else>
						<label class="col-xs-2 col-md-1 form-group">地址</label>
						<div class="col-xs-3 col-md-2 form-group">
							<select v-model="stu.resiCityId" name="resiCityId"  class="form-control" @change="getResiArea()">
								<option disabled value="">請選擇</option>
								<option v-for="(item,key) in cityList" :key="key" :value="item.cityId">{{ item.cityName }}
								</option>
							</select>
						</div>
						<div class="col-xs-3 col-md-2 form-group">
							<select v-model="stu.resiAreaId" name="resiAreaId"  class="form-control">
								<option disabled value="">請選擇</option>
								<option v-for="(item,key) in areaList" :key="key" :value="item.areaId">{{ item.areaName }}
								</option>
							</select>
						</div>
						<div class="col-xs-offset-util-3 col-xs-9 col-md-7 form-group">
							<input type="text" id="resiAddr" name="resiAddr" class="form-control" v-model="stu.resiAddr" placeholder="地址" maxlength="100"/>
						</div>
					</div>
				</div>
				<div class="row form-group col-md-12">
					<table class="table table-no-more table-bordered table-striped mb-none">
						<thead>
							<tr>
								<th class="text-center" style="width: 3%">序號</th>
								<th class="text-center" style="width: 25%;">學生關係人</th>
								<th class="text-center" style="width: 20%;">姓名</th>
								<th class="text-center" style="width: 20%;">身分證字號</th>
								<th class="text-center" style="width: 20%;">職業</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(kinship, index) in weakApply.kinshipList" :key="index">
								<td data-title="序號" class="text-center" style="vertical-align: middle;" :class="index == 0 || index == 1 || anyKinshipHasValue(kinship) ? 'column-required' : ''">{{index + 1}}</td>
								<td data-title="學生關係人" class="text-center">
                  <div :class="isKinshipDeletable(kinship) ? 'col-xs-1' : ''" :style="isKinshipDeletable(kinship) ? '' : 'display:none'">
                    <a @click="clearKinship(index)"><i class="fa fa-trash" style="font-size: 2rem;padding-top: 5px;"></i></a>
                  </div>
									<div :class="isKinshipDeletable(kinship) ? 'col-xs-6' : 'col-xs-7'">
										<select :id="'kinshipType_'+index" :name="'kinshipType_'+index" :ref="'kinshipType_'+index" v-model="kinship.kinshipType" v-validate="index == 0 || index == 1 || anyKinshipHasValue(kinship) ? 'required' : ''" class="form-control" :disabled="!isEditable">
											<option value="">請選擇</option>
											<option v-for="(item,key) in weakKinshipList" :key="key" :value="item.commCode">{{ item.commValue }}
											</option>
										</select>
										<span class="text-danger" v-show="errors.has(`kinshipType_${index}`)">{{ errors.first(`kinshipType_${index}`) }}</span>
									</div>
									<div class="col-xs-5">
										<select :id="'status_'+index" :name="'status_'+index" v-model="kinship.status"  v-validate="index == 0 || index == 1 || anyKinshipHasValue(kinship) ? 'required' : ''" class="form-control" :disabled="!isEditable"
										@change="() => {if(kinship.status != 'O'){kinship.statusValue = '';}}">
											<option value="">請選擇</option>
											<option v-for="(item,key) in weakKinshipStateList" :key="key" :value="item.commCode">{{ item.commValue }}
											</option>
										</select>
										<span class="text-danger" v-show="errors.has(`status_${index}`)">{{ errors.first(`status_${index}`) }}</span>
									</div>
								</td>
								<td data-title="姓名" style="vertical-align: middle;">
									<input :id="'name_'+index" :name="'name_'+index" v-validate="((index == 0 || index == 1 || anyKinshipHasValue(kinship)))  && (kinship.status != 'P' && kinship.status != 'O') ? 'required' : ''" v-model="kinship.name" type="text" class="form-control" :disabled="!isEditable" maxlength="20">
									<span class="text-danger" v-show="errors.has(`name_${index}`)">{{ errors.first(`name_${index}`) }}</span>
								</td>
								<td data-title="身分證字號" style="vertical-align: middle;">
									<input :id="'idNo_'+index" :name="'idNo_'+index" v-validate="((index == 0 || index == 1 || anyKinshipHasValue(kinship)))  && (kinship.status != 'P' && kinship.status != 'O' && kinship.status != 'D') ? `required|kinIdnoSex:kinshipType_${index}` : ''" v-model="kinship.idNo" type="text" class="form-control" :disabled="!isEditable" maxlength="10"
									@input="(e) => {kinship.idNo = e.target.value.toUpperCase()}">
									<span class="text-danger" v-show="errors.has(`idNo_${index}`)">{{ errors.first(`idNo_${index}`) }}</span>
								</td>
								<td data-title="職業" class="text-center">
									<div class="col-xs-6">
										<select :id="'occupationType_'+index" :name="'occupationType_'+index" v-validate="((index == 0 || index == 1 || anyKinshipHasValue(kinship)))  && (kinship.status != 'P' && kinship.status != 'O') ? 'required' : ''" v-model="kinship.occupationType" class="form-control" :disabled="!isEditable"
										@change="() => {if(kinship.occupationType != 'O'){kinship.occupationValue = '';}}">
											<option value="">請選擇</option>
											<option v-for="(item,key) in weakKinshipOccupationList" :key="key" :value="item.commCode">{{ item.commValue }}
											</option>
										</select>
										<span class="text-danger" v-show="errors.has(`occupationType_${index}`)">{{ errors.first(`occupationType_${index}`) }}</span>
									</div>
									<div class="col-xs-6">
										<input :id="'occupationValue_'+index" :name="'occupationValue_'+index" v-model="kinship.occupationValue" :disabled="!(kinship.occupationType == 'O' && isEditable)"
										v-validate="kinship.occupationType == 'O'? 'required' : ''" type="text" class="form-control" maxlength="10">
										<span class="text-danger" v-show="errors.has(`occupationValue_${index}`)">{{ errors.first(`occupationValue_${index}`) }}</span>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="row form-group">
					<div class="col-md-9 form-group">
						<label class="col-sm-2 col-xs-2 column-required">上學期學業成績</label>
						<div class="col-sm-10 col-xs-10 form-inline">
							<label for="lastSmtrScore">
								<input id="lastSmtrScore" name="lastSmtrScore" v-model="weakApply.lastSmtrScore" v-validate="weakApply.lastSmtrType == '' ? 'required|min_value:60' : ''" :disabled="!isEditable" type="number" style="width: 80px;" class="form-control"
								@input="(val) => {if(val != '') {weakApply.lastSmtrType = ''}}"/>
								<span>(未達60分無法申請)</span>
							</label>
							<label for="lastSmtrType_1">
								<input id="lastSmtrType_1" name="lastSmtrType_1" value="1" v-validate="weakApply.lastSmtrScore == '' ? 'required' : ''" v-model="weakApply.lastSmtrType" type="radio" class="radio-custom" :disabled="!isEditable"
								@change="() => {weakApply.lastSmtrScore = ''}"/>
								<span>新生免計成績</span>
							</label>
							<label for="lastSmtrType_2">
								<input id="lastSmtrType_2" name="lastSmtrType_2" value="2" v-validate="weakApply.lastSmtrScore == '' ? 'required' : ''" v-model="weakApply.lastSmtrType" type="radio" class="radio-custom" :disabled="!isEditable"
								@change="() => {weakApply.lastSmtrScore = ''}"/>
								<span>轉學生免計成績</span>
							</label>
							<span class="text-danger" v-show="errors.has('lastSmtrScore')">分數不得小於 60 </span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-9 form-group">
						<label for="householdFile" class="col-sm-4 col-xs-2 column-required">
							3個月內戶籍謄本或新式戶口名簿上傳(皆含詳細記事)<br/>
							<a href="javascript:;" class="btn-link" @mouseover="display()" @mouseout="disappear()">上傳範例</a>
							<div id="box" class="box" style="z-index:1000;"><h4 class="blue">新式戶口名簿樣本</h4><img src="../../../../assets/images/1595926019829.jpg" width="500px"></div>
						</label>
						<div v-if="householdFilePreview" class="col-sm-8 col-xs-10">
              <div>
                {{weakApply.householdFile}}
                <a v-if="isEditable" type="button" @click="() => {householdFilePreview = null}" style="color: #337ab7;cursor: pointer;">重傳檔案</a>
              </div>
							<a v-if="IsPdf(weakApply.householdFile)" :href="getPreviewUrl(weakApply.householdFile)" style="color: #337ab7" target="_blank">檔案預覽</a>
							<div v-else-if="IsValidPreviewExt(weakApply.householdFile)" class="col-xs-offset-util-2 col-xs-8 col-md-offset-util-2 col-md-8" >
								<a :href="getPreviewUrl(weakApply.householdFile)" target="_blank">
									<img class="img-fluid" :src="getPreviewUrl(weakApply.householdFile)" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input type="file" id="householdFile" name="householdFile" accept=".pdf,image/*" @change="getHouseholdFile($event)" v-validate="'required'" />
							<span class="text-danger" v-show="errors.has('householdFile')">{{ errors.first('householdFile') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="!isShowPrintBtn">
					<div class="col-md-9 form-group">
						<label for="affidavitFile" class="col-sm-4 col-xs-2 column-required">
							上傳申請書(請檢查申請書是否已簽名)<br/>
						</label>
						<div v-if="affidavitFilePreview" class="col-sm-8 col-xs-10">
              <div>
                {{weakApply.affidavitFile}}
                <a v-if="(!weakApply.schReviewState || weakApply.schReviewState == '0' || ((weakApply.schReviewState == '4' || weakApply.schReviewState == '5') && !isAdmin('assist')) ||
							 ((weakApply.schReviewState == '1' || weakApply.schReviewState == '6') && isAdmin('assist')))" type="button" @click="() => {affidavitFilePreview = null}" style="color: #337ab7;cursor: pointer;">重傳檔案</a>
              </div>
							<a v-if="IsPdf(weakApply.affidavitFile)" :href="getPreviewUrl(weakApply.affidavitFile)" style="color: #337ab7" target="_blank">檔案預覽</a>
							<div v-else-if="IsValidPreviewExt(weakApply.affidavitFile)" class="col-xs-offset-util-2 col-xs-8 col-md-offset-util-2 col-md-8" >
								<a :href="getPreviewUrl(weakApply.affidavitFile)" target="_blank">
									<img class="img-fluid" :src="getPreviewUrl(weakApply.affidavitFile)" alt="" style="width:200px; "/>
								</a>
							</div>
						</div>
						<div v-else class="col-sm-8 col-xs-10">
							<input type="file" id="affidavitFile" name="affidavitFile" accept=".pdf,image/*" @change="getAffidavitFile($event)" v-validate="'required'" />
							<span class="text-danger" v-show="errors.has('affidavitFile')">{{ errors.first('affidavitFile') }}</span>
						</div>
					</div>
				</div>
        <div v-if="isAdmin('assist') && weakApply.schReviewState != '0' && !!weakApply.schReviewState" class="row form-group">
          <div class="col-sm-12">
            <label>隱私權及個人資料保護政策宣告：{{ (customFormatter(weakApply.crDate, "YYYY")-1911) + customFormatter(weakApply.crDate, "年MM月DD日") }} 第{{ !!weakApply.privacyTreatyVersion ? weakApply.privacyTreatyVersion : "1.0" }}版</label>
          </div>
        </div>
				<div class="row form-group" v-if="weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-sm-12">
						<h4 style="font-weight: bold;">學校初審</h4>
					</div>
				</div>
        <div class="row form-group" v-if="isAdmin('assist') && weakApply.schReviewState != '0' && !!weakApply.schReviewState">
          <div class="col-md-9 form-group">
            <label for="discardIncomeFile" class="col-sm-4 col-xs-2">
              不列計所得切結書
            </label>
            <div v-if="discardIncomeFilePreview" class="col-sm-8 col-xs-10">
              <div>
                {{weakApply.discardIncomeFile}}
                <a v-if="isEditable" type="button" @click="() => {discardIncomeFilePreview = null}" style="color: #337ab7;cursor: pointer;">重傳檔案</a>
              </div>
              <a v-if="IsPdf(weakApply.discardIncomeFile)" :href="getPreviewUrl(weakApply.discardIncomeFile)" style="color: #337ab7" target="_blank">檔案預覽</a>
              <div v-else-if="IsValidPreviewExt(weakApply.discardIncomeFile)" class="col-xs-offset-util-2 col-xs-8 col-md-offset-util-2 col-md-8" >
                <a :href="getPreviewUrl(weakApply.discardIncomeFile)" target="_blank">
                  <img class="img-fluid" :src="getPreviewUrl(weakApply.discardIncomeFile)" alt="" style="width:200px; "/>
                </a>
              </div>
            </div>
            <div v-else class="col-sm-8 col-xs-10">
              <input type="file" id="discardIncomeFile" name="discardIncomeFile" accept=".pdf,image/*" @change="getDiscardIncomeFile($event)" />
              <span class="text-danger" v-show="errors.has('discardIncomeFile')">{{ errors.first('discardIncomeFile') }}</span>
            </div>
          </div>
        </div>
				<div class="row form-group" v-if="weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-sm-3">
						<select id="schReviewState" name="schReviewState" v-validate="'required'" v-model="weakApply.schReviewState" class="form-control" :disabled="!isAdmin('assist')">
							<option v-for="(item,key) in schreviewStateList" :key="key" :value="item.commCode">{{ item.commValue }}
							</option>
						</select>
						<span v-if="(weakApply.schReviewState == '4' || weakApply.schReviewState == '5') && !isAdmin('assist')">若需調整申請書以外的資訊，請點擊下方「編輯資料」。</span>
					</div>
				</div>
				<div v-if="weakApply.schReviewState == '3' || weakApply.schReviewState == '4' || weakApply.schReviewState == '5'" class="row form-group">
					<div class="col-sm-12">
						<label for="schReviewContent">{{schreviewStateList.filter(state => state.commCode == weakApply.schReviewState)[0].commValue}}說明</label>
						<textarea id="schReviewContent" name="schReviewContent" v-model="weakApply.schReviewContent" rows="3" class="form-control" :disabled="!isAdmin('assist')">
						</textarea>
					</div>
					<hr/>
				</div>
        <hr/>
				<!-- 課程加退選金額 -->
				<div class="row form-group" v-if="isAdmin('assist') && weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-sm-12">
						<h4 style="font-weight: bold;">課程 加退選金額</h4>
					</div>
				</div>
				<div class="row form-group col-md-12" v-if="isAdmin('assist') && weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-sm-12" style="margin-bottom: 5px; font-weight: bold;">上學期</div>
					<div class="col-sm-6 form-group">
						<label for="dropHour1" class="col-sm-2 col-xs-1">退選時數</label>
						<div class="col-sm-3 col-xs-2">
							<input id="dropHour1" name="dropHour1" v-model="weakApply.dropHour1" type="number" class="form-control" @input="calcFeeInfo()"/>
						</div>
						<span v-if="hasNightAddDropHint('smtr1')">{{ getNightAddDropHint('smtr1', '-') }}</span>
					</div>
					<div class="col-sm-6 form-group">
						<label for="addHour1" class="col-sm-2 col-xs-1">加選時數</label>
						<div class="col-sm-3 col-xs-2">
							<input id="addHour1" name="addHour1" v-model="weakApply.addHour1" type="number" class="form-control" @input="calcFeeInfo()"/>
						</div>
						<span v-if="hasNightAddDropHint('smtr1')">{{ getNightAddDropHint('smtr1', '+') }}</span>
					</div>
					<div class="col-sm-12" style="margin-top: 10px; margin-bottom: 5px; font-weight: bold;">下學期</div>
					<div class="col-sm-6 form-group">
						<label for="dropHour2" class="col-sm-2 col-xs-1">退選時數</label>
						<div class="col-sm-3 col-xs-2">
							<input id="dropHour2" name="dropHour2" v-model="weakApply.dropHour2" type="number" class="form-control" @input="calcFeeInfo()"/>
						</div>
						<span v-if="hasNightAddDropHint('smtr2')">{{ getNightAddDropHint('smtr2', '-') }}</span>
					</div>
					<div class="col-sm-6 form-group">
						<label for="addHour2" class="col-sm-2 col-xs-1">加選時數</label>
						<div class="col-sm-3 col-xs-2">
							<input id="addHour2" name="addHour2" v-model="weakApply.addHour2" type="number" class="form-control" @input="calcFeeInfo()"/>
						</div>
						<span v-if="hasNightAddDropHint('smtr2')">{{ getNightAddDropHint('smtr2', '+') }}</span>
					</div>
				</div>
				<!-- 費用資訊 -->
				<div v-if="isAdmin('assist') && weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="row form-group">
						<div class="col-sm-12">
							<h4 style="font-weight: bold;">費用資訊(表格中，「正常」「應收」欄位值，從學雜費系統中帶入){{!!feeInfoError ? `(${feeInfoError})` : ''}}</h4>
							<a class="btn-link" style="cursor: pointer;" @click="calcFeeInfo()">重新計算費用資訊</a>
							<a v-if="feeInfoError == '沒有該學生申請學期的費用資料'" class="btn-link" style="cursor: pointer; margin-left: 10px;" @click="syncSchoolFee()">同步學雜費資料</a>
						</div>
					</div>
					<template v-if="getSmtrFee('smtr1')">
						<div class="row form-group col-md-12">
							<table class="table table-no-more table-bordered table-striped mb-none">
								<thead>
									<tr>
										<th class="text-center" style="width:8%"></th>
										<th class="text-center" colspan="5">正常</th>
										<th class="text-center" colspan="5">課程 加退選（僅進修部使用）</th>
										<th class="text-center" colspan="5">休、退學</th>
									</tr>
									<tr>
										<th class="text-center">上學期</th>
										<th class="text-center">A應收</th>
										<th class="text-center">B行政院減免</th>
										<th class="text-center">C弱勢補助金額</th>
										<th class="text-center">D弱勢補助預扣</th>
										<th class="text-center">E應繳</th>
										<th class="text-center">P應收</th>
										<th class="text-center">Q行政院減免</th>
										<th class="text-center">R弱勢補助金額</th>
										<th class="text-center">S弱勢補助預扣</th>
										<th class="text-center">T應繳</th>
										<th class="text-center">K應收</th>
										<th class="text-center">L行政院減免</th>
										<th class="text-center">M弱勢補助金額</th>
										<th class="text-center">N弱勢補助預扣</th>
										<th class="text-center">O應繳</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>1學費：</td>
										<td class="text-center">{{getSmtrFee('smtr1').aTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr1').bTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr1').cTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr1').dTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr1').eTuition}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').pTuition != null ? getSmtrFee('smtr1').pTuition : ""}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr1').qTuition != null ? getSmtrFee('smtr1').qTuition : ""}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr1').rTuition != null ? getSmtrFee('smtr1').rTuition : ""}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr1').sTuition != null ? getSmtrFee('smtr1').sTuition : ""}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr1').tTuition != null ? getSmtrFee('smtr1').tTuition : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').kTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr1').lTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr1').mTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr1').nTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr1').oTuition != null ? getSmtrFee('smtr1').oTuition : ""}}</td>
									</tr>
									<tr>
										<td>2雜費：</td>
										<td class="text-center">{{getSmtrFee('smtr1').aMisce}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').pMisce != null ? getSmtrFee('smtr1').pMisce : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').kMisce}}</td>
									</tr>
									<tr>
										<td>3保險費：</td>
										<td class="text-center">{{getSmtrFee('smtr1').aBenefits}}</td>
										<td class="text-center">0</td>
										<td class="text-center">0</td>
										<td class="text-center">0</td>
										<td class="text-center">{{getSmtrFee('smtr1').eBenefits}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').pBenefits}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').showAddDrop ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').showAddDrop ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').showAddDrop ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').tBenefits}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').kBenefits}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').showRefund ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').showRefund ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').showRefund ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').oBenefits != null ? getSmtrFee('smtr1').oBenefits : ""}}</td>
									</tr>
									<tr>
										<td>4電腦使用費：</td>
										<td class="text-center">{{getSmtrFee('smtr1').aComputer}}</td>
										<td class="text-center">0</td>
										<td class="text-center">0</td>
										<td class="text-center">0</td>
										<td class="text-center">{{getSmtrFee('smtr1').aComputer}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').pComputer}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').showAddDrop ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').showAddDrop ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').showAddDrop ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').pComputer}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').kComputer}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').showRefund ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').showRefund ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').showRefund ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').oComputer != null ? getSmtrFee('smtr1').oComputer : ""}}</td>
									</tr>
									<tr>
										<td>合計</td>
										<td class="text-center">{{getSmtrFee('smtr1').aTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').bTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').cTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').dTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').eTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').pTotal != null ? getSmtrFee('smtr1').pTotal : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').qTotal != null ? getSmtrFee('smtr1').qTotal : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').rTotal != null ? getSmtrFee('smtr1').rTotal : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').sTotal != null ? getSmtrFee('smtr1').sTotal : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').tTotal != null ? getSmtrFee('smtr1').tTotal : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').kTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').lTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').mTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').nTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr1').oTotal != null ? getSmtrFee('smtr1').oTotal : ""}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="row form-group col-md-12" style="display: grid; float: inherit;">
							<div class="col-12" style="margin: 10px 0 0 0; display: flex; align-items: center;">
								<div class="col-lg-2" style="font-weight: bold;">繳費資訊：(出納系統)</div>
								<div class="col-lg-2">銀行金額 {{getSmtrFee('smtr1').paymoney}}</div>
								<div class="col-lg-2">出納金額 {{getSmtrFee('smtr1').paymoneyCash}}</div>
								<div class="col-lg-2">就學貸款 {{getSmtrFee('smtr1').realloan}}</div>
								<div class="col-lg-2">繳費日期 {{getSmtrFee('smtr1').paydate}}</div>
							</div>
						</div>
					</template>
					<template v-if="getSmtrFee('smtr2')">
						<div class="row form-group col-md-12">
							<table class="table table-no-more table-bordered table-striped mb-none">
								<thead>
									<tr v-if="!getSmtrFee('smtr1')">
										<th class="text-center" style="width:8%"></th>
										<th class="text-center" colspan="5">正常</th>
										<th class="text-center" colspan="5">課程 加退選（僅進修部使用）</th>
										<th class="text-center" colspan="5">休、退學</th>
									</tr>
									<tr>
										<th class="text-center" style="width:8%">下學期</th>
										<th class="text-center">A應收</th>
										<th class="text-center">B行政院減免</th>
										<th class="text-center">C弱勢補助金額</th>
										<th class="text-center">D弱勢補助預扣</th>
										<th class="text-center">E應繳</th>
										<th class="text-center">P應收</th>
										<th class="text-center">Q行政院減免</th>
										<th class="text-center">R弱勢補助金額</th>
										<th class="text-center">S弱勢補助預扣</th>
										<th class="text-center">T應繳</th>
										<th class="text-center">K應收</th>
										<th class="text-center">L行政院減免</th>
										<th class="text-center">M弱勢補助金額</th>
										<th class="text-center">N弱勢補助預扣</th>
										<th class="text-center">O應繳</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>1學費：</td>
										<td class="text-center">{{getSmtrFee('smtr2').aTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr2').bTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr2').cTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr2').dTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr2').eTuition}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').pTuition != null ? getSmtrFee('smtr2').pTuition : ""}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr2').qTuition != null ? getSmtrFee('smtr2').qTuition : ""}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr2').rTuition != null ? getSmtrFee('smtr2').rTuition : ""}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr2').sTuition != null ? getSmtrFee('smtr2').sTuition : ""}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr2').tTuition != null ? getSmtrFee('smtr2').tTuition : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').kTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr2').lTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr2').mTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr2').nTuition}}</td>
										<td class="text-center" rowspan="2">{{getSmtrFee('smtr2').oTuition != null ? getSmtrFee('smtr2').oTuition : ""}}</td>
									</tr>
									<tr>
										<td>2雜費：</td>
										<td class="text-center">{{getSmtrFee('smtr2').aMisce}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').pMisce != null ? getSmtrFee('smtr2').pMisce : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').kMisce}}</td>
									</tr>
									<tr>
										<td>3保險費：</td>
										<td class="text-center">{{getSmtrFee('smtr2').aBenefits}}</td>
										<td class="text-center">0</td>
										<td class="text-center">0</td>
										<td class="text-center">0</td>
										<td class="text-center">{{getSmtrFee('smtr2').eBenefits}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').pBenefits}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').showAddDrop ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').showAddDrop ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').showAddDrop ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').tBenefits}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').kBenefits}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').showRefund ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').showRefund ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').showRefund ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').oBenefits != null ? getSmtrFee('smtr2').oBenefits : ""}}</td>
									</tr>
									<tr>
										<td>4電腦使用費：</td>
										<td class="text-center">{{getSmtrFee('smtr2').aComputer}}</td>
										<td class="text-center">0</td>
										<td class="text-center">0</td>
										<td class="text-center">0</td>
										<td class="text-center">{{getSmtrFee('smtr2').aComputer}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').pComputer}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').showAddDrop ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').showAddDrop ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').showAddDrop ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').pComputer}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').kComputer}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').showRefund ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').showRefund ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').showRefund ? 0 : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').oComputer != null ? getSmtrFee('smtr2').oComputer : ""}}</td>
									</tr>
									<tr>
										<td>合計</td>
										<td class="text-center">{{getSmtrFee('smtr2').aTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').bTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').cTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').dTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').eTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').pTotal != null ? getSmtrFee('smtr2').pTotal : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').qTotal != null ? getSmtrFee('smtr2').qTotal : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').rTotal != null ? getSmtrFee('smtr2').rTotal : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').sTotal != null ? getSmtrFee('smtr2').sTotal : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').tTotal != null ? getSmtrFee('smtr2').tTotal : ""}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').kTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').lTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').mTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').nTotal}}</td>
										<td class="text-center">{{getSmtrFee('smtr2').oTotal != null ? getSmtrFee('smtr2').oTotal : ""}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="row form-group col-md-12" style="display: grid; float: inherit;">
							<div class="col-12" style="margin: 10px 0 0 0; display: flex; align-items: center;">
								<div class="col-lg-2" style="font-weight: bold;">繳費資訊：(出納系統)</div>
								<div class="col-lg-2">銀行金額 {{getSmtrFee('smtr2').paymoney}}</div>
								<div class="col-lg-2">出納金額 {{getSmtrFee('smtr2').paymoneyCash}}</div>
								<div class="col-lg-2">就學貸款 {{getSmtrFee('smtr2').realloan}}</div>
								<div class="col-lg-2">繳費日期 {{getSmtrFee('smtr2').paydate}}</div>
							</div>
						</div>
					</template>
					<hr/>
				</div>
				<div class="row form-group" v-if="weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-sm-12">
						<h4 style="font-weight: bold;">教育部(財稅中心)審核紀錄</h4>
					</div>
				</div>
				<div class="row form-group col-md-12" v-if="weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-12" style="margin: 10px 0 0 0;display: flex;align-items: center;">
						<div class="col-lg-2">
							查核級別：{{getClassText(weakApply.moeReviewClass)}}
						</div>
						<div class="col-lg-2">
							利息級距：
              <span :style="weakApply.moeReviewInterest == '不合格' ? {color: 'red'} : {}">{{weakApply.moeReviewInterest}}</span>
						</div>
						<div class="col-lg-2">
							土地不動產級距：
              <span :style="weakApply.moeReviewEstate == '不合格' ? {color: 'red'} : {}">{{weakApply.moeReviewEstate}}</span>
						</div>
						<div class="col-lg-2" >
							查核結果：
              <span :style="weakApply.moeReview == '不合格' ? {color: 'red'} : {}">{{weakApply.moeReview}}</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-sm-12">
						<h4 style="font-weight: bold;">補助金發放部別及金額</h4>
					</div>
				</div>
				<div class="row form-group col-md-12" v-if="weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="col-12" style="margin: 10px 0 0 0;display: flex;align-items: center;">
						<div class="col-lg-2">
							發放部別：{{weakApply.moeReviewMinistry}}
						</div>
						<div class="col-lg-2">
							已發放金額：{{weakApply.paidAmount}}
						</div>
						<div class="col-lg-2">
							弱勢補助金額：{{weakApply.weakAmount}}
						</div>
						<div class="col-lg-2">
							學校自籌金額：{{weakApply.schAmount}}
						</div>
						<div class="col-lg-2">
							教育部補助金額：{{weakApply.moeAmount}}
						</div>
					</div>
          <hr/>
          <div class="row form-group">
            <div class="col-sm-6">
              <div class="col-sm-3">放棄</div>
              <div class="col-sm-3" style="display: flex;">
                <div class="checkbox-custom">
                  <input id="abandon" name="abandon" type="checkbox" value="Y" v-model="weakApply.abandon"  :disabled="!isAdmin('assist')">
                  <label for="abandon">是</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-sm-6" v-if="weakApply.abandon">
              <label  class="col-sm-3" for="abandonContent">放棄說明</label>
              <div class=" col-sm-6">
                  <textarea id="abandonContent" name="abandonContent" v-model="weakApply.abandonContent" rows="3" class="form-control" :disabled="!isAdmin('assist')">
                  </textarea>
              </div>
            </div>
          </div>
					<hr/>
				</div>
				<div v-if="isAdmin('assist') && weakApply.schReviewState != '0' && !!weakApply.schReviewState">
					<div class="row form-group">
						<div class="col-sm-12">
							<h4 style="font-weight: bold;">繳費資訊{{!!feeInfoError ? `(${feeInfoError})` : ''}}</h4>
							<a v-if="feeInfoError == '沒有該學生申請學期的費用資料'" class="btn-link" style="cursor: pointer;" @click="syncSchoolFee()">同步學雜費資料</a>
						</div>
					</div>
					<div class="row form-group col-md-12" style="display: grid;float: inherit;">
						<div class="col-12" style="margin: 10px 0 0 0;display: flex;align-items: center;">
							<div class="col-lg-2">
								應收學費總額：{{weakApply.feeInfo.totleTuition}}
							</div>
							<div class="col-lg-2">
								銀行金額：{{weakApply.feeInfo.paymoneyCash}}
							</div>
							<div class="col-lg-2">
								出納金額：{{weakApply.feeInfo.paymoney}}
							</div>
							<div class="col-lg-2">
								就學貸款：{{weakApply.feeInfo.realloan}}
							</div>
							<div class="col-lg-2">
								繳費日期：{{weakApply.feeInfo.paydate}}
							</div>
						</div>
					</div>
					<hr/>
				</div>
        <div class="row form-group" v-if="isAdmin('assist') && weakApply.schReviewState != '0' && !!weakApply.schReviewState">
          <div class="col-sm-12">
            <h4 style="font-weight: bold;">退費選項</h4>
          </div>
        </div>
        <div class="row form-group"  v-if="isAdmin('assist') && weakApply.schReviewState != '0' && !!weakApply.schReviewState">
          <div class="col-sm-6">
            <div class="col-sm-3">是否為休、退學學生</div>
            <div class="col-sm-3" style="display: flex;">
              <div class="checkbox-custom">
                <input id="isRefund" name="isRefund" type="checkbox" value="Y" v-model="weakApply.isRefund">
                <label for="isRefund">是</label>
              </div>

            </div>
          </div>
        </div>
				<div class="text-center form-group" v-if="(!weakApply.schReviewState || weakApply.schReviewState == '0' || weakApply.schReviewState == '4'|| weakApply.schReviewState == '5') && isShowPrintBtn">
					<button class="btn" v-if="JSON.stringify(this.sessionData) != '{}'" @click="gotoView('weak.list')">返回</button>
					<button class="btn s_btn_o" @click="handleSave(true)">儲存</button>
					<button class="btn s_btn_o" @click="handleSave()">儲存並預覽列印</button>
				</div>
				<div class="text-center form-group" v-else>
					<button class="btn" v-if="JSON.stringify(this.sessionData) != '{}'" @click="gotoView('weak.list')">返回</button>
					<button class="btn s_btn_g" @click="showPrintPopup(true)" v-if="(!weakApply.schReviewState || weakApply.schReviewState == '0' || ((weakApply.schReviewState == '4' || weakApply.schReviewState == '5') && !isAdmin('assist')))">列印申請書</button>
					<button class="btn s_btn_g" @click="backToEdit()" v-if="(!weakApply.schReviewState || weakApply.schReviewState == '0' || ((weakApply.schReviewState == '4' || weakApply.schReviewState == '5') && !isAdmin('assist')))">編輯資料</button>
					<button class="btn s_btn_o" @click="handleSave()" v-if="!weakApply.schReviewState || weakApply.schReviewState == '0' || weakApply.schReviewState == '4' || weakApply.schReviewState == '5' || isAdmin('assist')">送出</button>
				</div>
            </div>
		</section>
		<printPopup v-if="isShowPrintPopup"/>
	</div>
</template>
<script>
import printPopup from "./printPopup";
import treaty from "@/components/assist/treaty";
export default {
	components:{
		printPopup,
    treaty
	},
	data(){
		return {
			stu: {
				idno: "",
				name: "",
				sex: "",
				account:"",
				ssym: "",
				dept: "",
				drade: "",
				dradeClass: "",
				state: "01",
				entryYear: "",
				entryMonth: "",
				phone: "",
				schMail: "",
				extMail: "",
				resiAddr: "",
				resiCityId: "",
				resiAreaId: "",
				deptCode: "",
			},
			weakApply:{
				id: "",
				kinshipList: [
					{
						kinshipType: "",
						status: "",
						occupationType: ""
					},
					{
						kinshipType: "",
						status: "",
						occupationType: ""
					},
					{
						kinshipType: "",
						status: "",
						occupationType: ""
					}
				],
				lastSmtrScore: null,
				lastSmtrType: "",
				affidavitFile: "",
				householdFile: "",
        discardIncomeFile: "",
				schReviewState: "",
				schReviewContent: "",
				moeReviewClass: "",
				moeReviewInterest: "",
				moeReviewEstate: "",
				moeReview: "",
				moeReviewMinistry: "",
				moeReviewDesc: "",
				paidAmount: null,
				weakAmount: null,
				schAmount: null,
				moeAmount: null,
				isRefund: false,
				feeInfo: {},
        abandon: false,
        abandonContent: "",
        addHour1: "",
        dropHour1: "",
        addHour2: "",
        dropHour2: ""
			},
			// 下拉選單來源
			ssymList: [],
			deptList: [],
			cityList: [],
			areaList: [],
			weakKinshipList: [],
			weakKinshipStateList: [],
			weakKinshipOccupationList: [],
			weakScoreList: [],
			schreviewStateList: [],
			uStateList: [],
			dradeList: [
				{
					key: "1",
					value: "一年級"
				},
				{
					key: "2",
					value: "二年級"
				},
				{
					key: "3",
					value: "三年級"
				},
				{
					key: "4",
					value: "四年級"
				},
				{
					key: "5",
					value: "五年級"
				},
				{
					key: "6",
					value: "六年級"
				},
				{
					key: "7",
					value: "七年級"
				},
				{
					key: "8",
					value: "八年級"
				},
				{
					key: "9",
					value: "九年級"
				}
			],
			dradeClassList: [
				{
					key: "A",
					value: "A班"
				},
				{
					key: "B",
					value: "B班"
				},
				{
					key: "C",
					value: "C班"
				},
        {
          key: "D",
          value: "D班"
        },
			],
			//檔案
			householdFile: "",
			stuPhoto: "",
			affidavitFile: "",
      discardIncomeFile: "",
			householdFilePreview: "",
			affidavitFilePreview: "",
      discardIncomeFilePreview: "",

			// 判斷是否顯示列印按鈕
			isShowPrintBtn: false,

			// 判斷是否顯示列印畫面
			isShowPrintPopup: false,

			// 透過身分證字號查詢進入
			isFromIdnoSearch: false,

			// 顯示費用資料錯誤訊息
			feeInfoError: "",

      // 是否顯示條約
      isShowTreaty: false
		}

	},
	mounted(){
    if(this.$route.name == "weak.apply.new") {
      this.isShowTreaty = true;
    }
		this.pageInit();
	},
	methods:{
		pageInit(){
			let api = `/api/weak/editInit?isNew=${this.$route.name == "weak.apply.new"}`;
			this.$axios.get(api).then(res => {
				if (res.data.status == "success") {
					this.ssymList = res.data.data.selectList.ssym
					this.deptList = res.data.data.selectList.dept
					this.cityList = res.data.data.selectList.city
					this.weakKinshipList = res.data.data.selectList.weakKinship
					this.weakKinshipStateList = res.data.data.selectList.weakKinshipState
					this.weakKinshipOccupationList = res.data.data.selectList.weakKinshipOccupation
					this.weakScoreList = res.data.data.selectList.weakScore
					this.schreviewStateList = res.data.data.selectList.reviewState
					this.uStateList = res.data.data.selectList.uState

					if (this.getStore(this.$route.name) != null) {
						let storeData = JSON.parse(this.getStore(this.$route.name));
						if(storeData.weakApplyId != ""){
							api = `/api/weak/${storeData.weakApplyId}`;
							this.$axios.get(api).then(res => {
								this.stu = {
									...res.data.data.stu,
									ssym: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(0,1) : "",
									dept: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(1,2) : ""
								};
								this.weakApply = {
									...res.data.data.wa,
									feeInfo: res.data.data.wa.feeInfo == null ? {} : JSON.parse(res.data.data.wa.feeInfo)
								};

								// 補足三個關係人資料
								for(let i=0; i<3; i++){
									if(this.weakApply.kinshipList.length <= i ){
										this.weakApply.kinshipList[i] = {
											kinshipType: "",
											status: "",
											occupationType: ""
										}
									}
								}

								// 建立預覽連結
								this.householdFilePreview = this.getPreviewUrl(this.weakApply.householdFile);
                this.discardIncomeFilePreview = this.getPreviewUrl(this.weakApply.discardIncomeFile);
								this.affidavitFilePreview = this.getPreviewUrl(this.weakApply.affidavitFile);

                // 計算費用資訊
                if(JSON.stringify(this.weakApply.feeInfo) == '{}') {
                  this.calcFeeInfo();
                }
							});
						}

						if(storeData.isFromIdnoSearch != "") {
							this.isFromIdnoSearch = storeData.isFromIdnoSearch
						}
					} else {
						this.isShowPrintBtn = true;
					}


					if (this.$route.name == "weak.apply.new" && this.sessionData.accountType == "STU"){
						this.stu = {
							...res.data.data.stu,
							ssym: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(0,1) : "",
							dept: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(1,2) : ""
						};

						if(res.data.data.lastWeakApply != null && res.data.data.lastWeakApply.id != "") {
							this.weakApply.kinshipList = res.data.data.lastWeakApply.kinshipList;
              this.weakApply.discardIncomeFile = res.data.data.lastWeakApply.discardIncomeFile;

              // 補足三個關係人資料
							for(let i=0; i<3; i++){
								if(res.data.data.lastWeakApply.kinshipList.length <= i ){
									this.weakApply.kinshipList[i] = {
										kinshipType: "",
										status: "",
										occupationType: ""
									}
								}
							}
						}
					}


				} else if(res.data.status == "error"){
					bootbox.alert(res.data.msg);
					this.$router.back();
				}
			});
		},
    calcFeeInfo() {
      if(this.isAdmin('assist') && !(!this.weakApply.schReviewState || this.weakApply.schReviewState == '0')) {
        const api = "/api/weak/calc";
        const body = {
          ...this.weakApply,
          payInfo: '{}',
          feeInfo: '{}'
        }
        this.$axios.post(api, body).then(res => {
          if(res.data.status === "success") {
            this.weakApply.feeInfo = res.data.data;
            this.feeInfoError = "";
          } else if(res.data.status === "error") {
            this.feeInfoError = res.data.msg;
          }
        });
      }
    },
		handleSave(withoutPrint = false){
      var orgKinshipList = this.weakApply.kinshipList;
      this.weakApply.kinshipList = this.weakApply.kinshipList.filter(kin => this.anyKinshipHasValue(kin));
			this.$validator.validateAll().then((result) => {
				if (result) {
					if(this.weakApply.id === ""){
						this.handleCreate(withoutPrint)
					} else {
						this.handleUpdate(withoutPrint);
					}
				}
				else {
          // 還原關係人資料
          this.weakApply.kinshipList = orgKinshipList;
					bootbox.alert("請確認必填欄位是否有填寫正確，並至少填寫兩名關係人完整資料");
				}
			});
		},
		handleCreate(withoutPrint) {
			const api = "/api/weak";
			let formData = new FormData();

			this.stu.deptCode = this.stu.ssym + this.stu.dept;

			for(let key in this.stu) {
				if(this.stu[key]) {
					formData.append(`stu.${key}`, this.stu[key]);
				}
			}
			for(let key in this.weakApply) {
				if(this.weakApply[key]) {
					if(typeof(this.weakApply[key]) === "object") {
						if(Array.isArray(this.weakApply[key])) {
							for(let i = 0; i < this.weakApply[key].length; i++) {
								for(let k in this.weakApply[key][i]) {
									if(this.weakApply[key][i][k]) {
										formData.append(`weakApply.${key}[${i}].${k}`, this.weakApply[key][i][k]);
									}
								}
							}
						} else {
							formData.append(`weakApply.${key}`, JSON.stringify(this.weakApply[key]));
						}
					} else {
						formData.append(`weakApply.${key}`, this.weakApply[key]);
					}
				}
			}

			formData.append("householdFile", this.householdFile)
			this.$axios.post(api, formData).then(res => {
				if(res.data.status === "success") {
					this.weakApply.id = res.data.data.id;
					this.weakApply.year = res.data.data.year;
					if(withoutPrint) {
            			// 儲存未送出申請
						if(JSON.stringify(this.sessionData) != '{}') {
							bootbox.alert("儲存成功。<br/><b>提醒您，申請尚未完成，目前為草稿狀態</b>。<br/>請列印申請書後以拍照或掃描的方式上傳檔案至申請書欄位並送出，才算完成線上申請。");
							this.gotoView('weak.list');
						} else {
							bootbox.alert("儲存成功。<br/><b>提醒您，申請尚未完成，目前為草稿狀態</b>。<br/>請列印申請書後以拍照或掃描的方式上傳檔案至申請書欄位並送出，才算完成線上申請。<br/>若無法當下完成申請書上傳可透過「弱勢助學金申請查詢」功能，完成最後上傳步驟。");
							this.gotoView('weak.list', {idNo: this.stu.idno});
						}
					} else {
						this.showPrintPopup(true)
					}
				} else if(res.data.status === "error") {
					bootbox.alert(res.data.msg);
				}
			});
		},
		handleUpdate(withoutPrint) {
			if ((!this.weakApply.schReviewState || this.weakApply.schReviewState == '0' ||
				((this.weakApply.schReviewState == '4' || this.weakApply.schReviewState == '5') &&
				!this.isAdmin('assist'))) && !this.isShowPrintBtn) {
				this.submitApply();
			} else {
				const api = `/api/weak/${this.weakApply.id}`;
				let formData = new FormData();

				this.stu.deptCode = this.stu.ssym + this.stu.dept;
				for(let key in this.stu) {
					if(this.stu[key]) {
						formData.append(`stu.${key}`, this.stu[key]);
					}
				}

				for(let key in this.weakApply) {
					if(this.weakApply[key]) {
						if(typeof(this.weakApply[key]) === "object") {
							if(Array.isArray(this.weakApply[key])) {
								for(let i = 0; i < this.weakApply[key].length; i++) {
									for(let k in this.weakApply[key][i]) {
										if(this.weakApply[key][i][k]) {
											formData.append(`weakApply.${key}[${i}].${k}`, this.weakApply[key][i][k]);
										}
									}
								}
							} else {
								formData.append(`weakApply.${key}`, JSON.stringify(this.weakApply[key]));
							}
						} else {
							formData.append(`weakApply.${key}`, this.weakApply[key]);
						}
					}
				}

				formData.append("householdFile", this.householdFile);
        formData.append("affidavitFile", this.affidavitFile);
        formData.append("discardIncomeFile", this.discardIncomeFile);
				this.$axios.post(api, formData).then(res => {
					if(res.data.status === "success") {
						if ((!this.weakApply.schReviewState || this.weakApply.schReviewState == '0' || this.weakApply.schReviewState == '4'|| this.weakApply.schReviewState == '5') && this.isShowPrintBtn) {
							if(withoutPrint) {
								this.isShowPrintBtn = false;
								if(this.weakApply.schReviewState == '4'|| this.weakApply.schReviewState == '5'){
									// 補件
									bootbox.dialog({
										message: "儲存成功。<br/>請選擇是否沿用原本的申請書申請或是重新上傳？",
										buttons: {
											upload: {
												label: '重新上傳',
												callback: () => {
													this.$parent.isShowPrintBtn = false;
													this.affidavitFilePreview = null
												}
											},
											submit: {
												label: '送出申請',
												callback: () => {
													this.submitApply();
												}
											}
										}
									})
								} else {
									// 儲存未送出申請
									if(JSON.stringify(this.sessionData) != '{}') {
										bootbox.alert("儲存成功。<br/><b>提醒您，申請尚未完成，目前為草稿狀態</b>。<br/>請列印申請書後以拍照或掃描的方式上傳檔案至申請書欄位並送出，才算完成申請。");
										this.gotoView('weak.list');
									} else {
										bootbox.alert("儲存成功。<br/><b>提醒您，申請尚未完成，目前為草稿狀態</b>。<br/>請列印申請書後以拍照或掃描的方式上傳檔案至申請書欄位並送出，才算完成申請。<br/>若無法當下完成申請書上傳可透過「弱勢助學金申請查詢」功能，完成最後上傳步驟。");
										this.gotoView('weak.list', {idNo: this.stu.idno});
									}
								}
							} else {
								this.showPrintPopup(true)
							}
						} else if(this.isAdmin('assist')) {
							this.gotoView('weak.list')
						}
					} else if(res.data.status === "error") {
						bootbox.alert(res.data.msg);
					}
				});
			}
		},
		submitApply() {
			const api = `/api/weak/${this.weakApply.id}/affidavit`;
			let formData = new FormData();
			formData.append("affidavitFile", this.affidavitFile);
			this.$axios.post(api, formData).then(res => {
				if(res.data.status === "success") {
					if(JSON.stringify(this.sessionData) != '{}') {
						bootbox.alert("線上申請成功，可至弱勢助學金申請列表，來查詢申請狀態。<br/><b>重要 : 請將紙本文件繳交生輔組審核，未繳交紙本者，視同未申請。</b>");
						this.gotoView('weak.list');
					} else {
						bootbox.alert("線上申請成功，可透過「弱勢助學金申請查詢」功能，以身分證字號來查詢申請狀態。<br/><b style='color:red;'>重要 : 請將紙本文件繳交生輔組審核，未繳交紙本者，視同未申請。</b>");
						this.gotoView('weak.list', {idNo: this.stu.idno})
					}
				} else if(res.data.status === "error") {
					bootbox.alert(res.data.msg);
				}
			});
		},
		syncSchoolFee(){
			const api = `/api/weak/syncSchoolFee`;
			this.$axios.post(api).then(res => {
				if(res.data.status === "success") {
					bootbox.alert("同步完成");
					this.pageInit();
				} else if(res.data.status === "error") {
					bootbox.alert(res.data.msg);
				}
			});
		},
		getHouseholdFile(event) {
			this.householdFile = event.target.files[0];
			if(this.householdFile){
				if(this.checkFileExtension(this.householdFile.name, ["jpg","jpeg","png","pdf"])){
					this.weakApply.householdFile = this.householdFile.name;
					if (/^image/.test(this.householdFile.type)){
						this.compresImage(this.householdFile).then(result => {
							this.householdFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.householdFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
    getDiscardIncomeFile(event) {
      this.discardIncomeFile = event.target.files[0];
      if(this.discardIncomeFile){
        if(this.checkFileExtension(this.discardIncomeFile.name, ["jpg","jpeg","png","pdf"])){
          this.weakApply.discardIncomeFile = this.discardIncomeFile.name;
          if (/^image/.test(this.discardIncomeFile.type)){
            this.compresImage(this.discardIncomeFile).then(result => {
              this.discardIncomeFile = result;
            });
          }
        }else{
          bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
          this.discardIncomeFile = null;
        }
      }else{
        bootbox.alert("上傳失敗，請重新上傳。");
      }
    },
		getAffidavitFile(event) {
			this.affidavitFile = event.target.files[0];
			if(this.affidavitFile){
				if(this.checkFileExtension(this.affidavitFile.name, ["jpg","jpeg","png","pdf"])){
					this.weakApply.affidavitFile = this.affidavitFile.name;
					if (/^image/.test(this.affidavitFile.type)){
						this.compresImage(this.affidavitFile).then(result => {
							this.affidavitFile = result;
						});
					}
				}else{
					bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
					this.affidavitFile = null;
				}
			}else{
				bootbox.alert("上傳失敗，請重新上傳。");
			}

		},
		anyKinshipHasValue(kinship) {
			return !!kinship.kinshipType || !!kinship.status || !!kinship.occupationType || !!kinship.name || !!kinship.idNo;
		},
		hasNightAddDropHint(smtrKey) {
			const smtr = (this.weakApply.feeInfo || {})[smtrKey];
			return this.feeInfoError === "" && smtr && smtr.nightAddDropRuleMatched === true;
		},
		getNightAddDropHint(smtrKey, operator) {
			if (!this.hasNightAddDropHint(smtrKey)) return "";
			const smtr = this.weakApply.feeInfo[smtrKey];
			return `原應收學費${operator}(${smtr.nightAddDropCreditUnitFee}x時數)，原應收雜費${operator}(${smtr.nightAddDropMiscUnitFee}x時數)`;
		},
		getSmtrFee(smtrKey) {
			const s = (this.weakApply.feeInfo || {})[smtrKey];
			if (!s) return null;
			const hasNight = s.nightAddDropRuleMatched;
			// 學費列的 E 應繳 = 學費+雜費-行政院減免-預扣(雜費列不另計,照需求文件)
			const eTuition = Math.max(0, s.tuiCreditFee + s.tuiMisceFee - s.govReduction - s.preDeductedTuition);
			const pFee = hasNight ? s.nightTuiCreditFee + s.nightTuiMisceFee : null;
			const tTuition = hasNight ? Math.max(0, pFee - s.nightGovReduction - s.nightPreDeducted) : null;
			// 保險費應繳 = 應收 - 50(固定值)
			const eBenefits = s.tuiBenefits > 0 ? Math.max(0, s.tuiBenefits - 50) : 0;
			// 休退學(K~O):有加退選值用加退選後值,否則用正常值;O 應繳僅上學期計算,下學期留空白
			const isSmtr1 = smtrKey === "smtr1";
			const kTuition = hasNight ? s.nightTuiCreditFee : s.tuiCreditFee;
			const kMisce = hasNight ? s.nightTuiMisceFee : s.tuiMisceFee;
			const lTuition = hasNight ? s.nightGovReduction : s.govReduction;
			const nTuition = s.withdrawPreDeducted || 0;
			const oTuition = isSmtr1 ? Math.max(0, kTuition + kMisce - lTuition) : null;
			const oBenefits = isSmtr1 ? eBenefits : null;
			const fee = {
				aTuition: s.tuiCreditFee,
				bTuition: s.govReduction,
				cTuition: s.weakAmount,
				dTuition: s.preDeductedTuition,
				eTuition,
				pTuition: hasNight ? s.nightTuiCreditFee : null,
				qTuition: hasNight ? s.nightGovReduction : null,
				rTuition: hasNight ? s.weakAmount : null,
				sTuition: hasNight ? s.nightPreDeducted : null,
				tTuition,
				aMisce: s.tuiMisceFee,
				pMisce: hasNight ? s.nightTuiMisceFee : null,
				aBenefits: s.tuiBenefits,
				eBenefits,
				pBenefits: s.tuiBenefits,
				tBenefits: eBenefits,
				aComputer: s.tuiComputerFee,
				pComputer: s.tuiComputerFee,
				aTotal: s.tuiCreditFee + s.tuiMisceFee + s.tuiBenefits + s.tuiComputerFee,
				bTotal: s.govReduction,
				cTotal: s.weakAmount,
				dTotal: s.preDeductedTuition,
				eTotal: eTuition + eBenefits + s.tuiComputerFee,
				pTotal: hasNight ? pFee + s.tuiBenefits + s.tuiComputerFee : null,
				qTotal: hasNight ? s.nightGovReduction : null,
				rTotal: hasNight ? s.weakAmount : null,
				sTotal: hasNight ? s.nightPreDeducted : null,
				tTotal: hasNight ? tTuition + eBenefits + s.tuiComputerFee : null,
				paymoney: s.paymoney,
				paymoneyCash: s.paymoneyCash,
				realloan: s.realloan,
				paydate: s.paydate,
				kTuition,
				kMisce,
				kBenefits: s.tuiBenefits,
				kComputer: s.tuiComputerFee,
				lTuition,
				mTuition: s.weakAmount,
				nTuition,
				oTuition,
				oBenefits,
				oComputer: isSmtr1 ? s.tuiComputerFee : null,
				kTotal: kTuition + kMisce + s.tuiBenefits + s.tuiComputerFee,
				lTotal: lTuition,
				mTotal: s.weakAmount,
				nTotal: nTuition,
				oTotal: isSmtr1 ? oTuition + eBenefits + s.tuiComputerFee : null,
				hasNight
			};
			// P~T(加退選):只要有填加退選時數且命中進修部加退選費率(hasNight)即顯示,與休退學無關
			//           (與上方公式提示 hasNightAddDropHint 的條件一致);K~O(休退學):勾選休退學才顯示,否則留空
			const isRefund = !!this.weakApply.isRefund;
			fee.showAddDrop = hasNight;
			fee.showRefund = isRefund;
			if (!fee.showAddDrop) {
				["pTuition", "qTuition", "rTuition", "sTuition", "tTuition", "pMisce", "pBenefits", "tBenefits", "pComputer", "pTotal", "qTotal", "rTotal", "sTotal", "tTotal"].forEach(k => fee[k] = null);
			}
			if (!isRefund) {
				["kTuition", "kMisce", "kBenefits", "kComputer", "lTuition", "mTuition", "nTuition", "oTuition", "oBenefits", "oComputer", "kTotal", "lTotal", "mTotal", "nTotal", "oTotal"].forEach(k => fee[k] = null);
			}
			return fee;
		},
		showPrintPopup(isOpen) {
			this.isShowPrintPopup = isOpen
		},
		backToEdit() {
			this.isShowPrintBtn = true;
		},
		async getResiArea() {
			this.stu.resiAreaId = "";
			this.stu.resiRoadId = "";
			this.stu.resiAreaList = [];
			this.stu.resiRoadList = [];
			const api = "/api/Common/getArea/" + this.stu.resiCityId;
			let resp = await this.$axios.post(api);
			if(resp.data.status == "success"){
				this.areaList = resp.data.data.areaList;
			}
		},
		IsPdf(filePath) {
			if(filePath != null && filePath != ""){
				var ext = filePath.substring(filePath.lastIndexOf('.') + 1).toLowerCase();
				if(ext == "pdf"){
					return true;
				}else{
					return false;
				}
			}
			return false;
		},
		IsValidPreviewExt(filePath) {
			if(filePath != null && filePath != ""){
				var ext = filePath.substring(filePath.lastIndexOf('.') + 1).toLowerCase();
				if(ext == "jpg" || ext == "jpeg" || ext == "png" || ext == "pdf"){
					return true;
				}else{
					return false;
				}
			}
			return false;
		},
		getPreviewUrl(filePath) {
			let url = "";
			if(this.IsValidPreviewExt(filePath)) {
				url = "/upload/" + filePath;
			}
			return url;
		},
		display() {
			document.getElementById("box").style.display = "block";
		},
		disappear() {
			document.getElementById("box").style.display = "none";
		},
    getClassText(value) {
      switch (value){
        case "1":
          return "第一級";
        case "2":
          return "第二級";
        case "3":
          return "第三級";
        case "4":
          return "第四級";
        case "5":
          return "第五級";
        case "6":
          return "第六級";
        default:
          return ""
      }
    },
    clearKinship(index) {
      this.weakApply.kinshipList.splice(index, 1);
      this.weakApply.kinshipList.push({
        kinshipType: "",
        status: "",
        occupationType: ""
      });
    },
    isKinshipDeletable(kinship){
      // 管理員在待審狀態可以編輯
      if(!this.isAdmin('assist') || !(this.weakApply.schReviewState == "1" || this.weakApply.schReviewState == "6")) {
        return false;
      }
      // 有兩個以上關係人
      if(this.weakApply.kinshipList.filter(kin => this.anyKinshipHasValue(kin)).length === 1) {
        return false;
      }
      // 關係人狀態為「離」
      if(!!kinship && kinship.status !== 'D') {
        return false;
      }
      return true;
    },
    getLastYearData() {
      if(this.isAdmin('assist') && this.stu.account.length == 9) {
        let api = `/api/weak/lastYearData?account=${this.stu.account}`;
        this.$axios.get(api).then(res => {
          if (res.data.status == "success") {
            if(res.data.data != null){
              this.stu = {
                ...res.data.data.stu,
                ssym: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(0,1) : "",
                dept: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(1,2) : ""
              };

              if(res.data.data.lastWeakApply != null && res.data.data.lastWeakApply.id != "") {
                this.weakApply.kinshipList = res.data.data.lastWeakApply.kinshipList;
                this.weakApply.discardIncomeFile = res.data.data.lastWeakApply.discardIncomeFile;

                // 補足三個關係人資料
                for(let i=0; i<3; i++){
                  if(res.data.data.lastWeakApply.kinshipList.length <= i ){
                    this.weakApply.kinshipList[i] = {
                      kinshipType: "",
                      status: "",
                      occupationType: ""
                    }
                  }
                }
              }
            }
          } else if(res.data.status == "error"){
            bootbox.alert(res.data.msg);
            this.$router.back();
          }
        });
      }
    }
	},
	computed: {
		isInfo(){
			return this.$route.name != "weak.apply.new" || this.sessionData.accountType == "STU";
		},
		isEditable(){
			// 管理員在待審狀態可以編輯
			// 申請人或透過身分證查詢在草稿或待補件狀態可以編輯
			return (this.isAdmin('assist') && (this.weakApply.schReviewState == "1" || this.weakApply.schReviewState == "6")) ||
			 (this.sessionData.account == this.weakApply.account && (
				 this.weakApply.schReviewState == "0" || this.weakApply.schReviewState == "4"|| this.weakApply.schReviewState == "5") && this.isShowPrintBtn) ||
			 (this.isFromIdnoSearch && (
				 this.weakApply.schReviewState == "0" || this.weakApply.schReviewState == "4"|| this.weakApply.schReviewState == "5") && this.isShowPrintBtn) ||
			 (!this.weakApply.schReviewState && this.isShowPrintBtn);
		}
	},
	watch:{
		"stu.idno": function (val) {
			if(val){
				this.stu.idno = val.toUpperCase();
			}
		}
	},
	beforeRouteLeave(to, from, next) {
		this.removeStore(this.$route.name);
		next();
	}
}
</script>
<style>
</style>
